import { IExtendableDto, SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import { IAreaDto, IAreaPolygonDto, IRydeProcess } from "../models";

interface IImportFromGeoAreasParams {
  geoAreasIds: number[];
}

interface IFindByCoordinates {
  lat: number;
  lng: number;
}

export class AreaApi {
  static async importFromGeoAreas({
    geoAreasIds,
  }: IImportFromGeoAreasParams): Promise<
    SimpleResult<IExtendableDto[]> | undefined
  > {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/areas/import-from-geo-areas`;
    const response = await Api.post<SimpleResult<IExtendableDto[]> | undefined>(
      requestUrl,
      { geoAreasIds },
    );

    return response?.data;
  }

  // BULK - PROCESS import areas from geo areas
  static async bulkImportFromGeoAreas({
    geoAreasIds,
  }: IImportFromGeoAreasParams): Promise<
    SimpleResult<IRydeProcess> | undefined
  > {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/areas/bulk/import-from-geo-areas`;
    const response = await Api.post<SimpleResult<IRydeProcess> | undefined>(
      requestUrl,
      { payload: { geoAreasIds } },
    );
    return response?.data;
  }

  static async findByCoordinates({
    lat,
    lng,
  }: IFindByCoordinates): Promise<IAreaDto[] | undefined> {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/areas/find-by-coordinate`;
    const response = await Api.get<IAreaDto[] | undefined>(requestUrl, {
      lat,
      lng,
    });

    return response?.data;
  }

  static async getPolygonsByIds(
    ids: number[],
  ): Promise<SimpleResult<IAreaPolygonDto[]> | undefined> {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/areas/polygons`;
    const response = await Api.post<
      SimpleResult<IAreaPolygonDto[]> | undefined
    >(requestUrl, {
      ids,
    });

    return response?.data;
  }
}
